import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { InvoiceBatchExportSummary } from "../../../models/InvoiceBatch";
import { describeExportSummary } from "../../../utils/invoiceExport.utils";

interface Props {
	summary?: InvoiceBatchExportSummary;
}

/**
 * List badge for a processed batch with open export follow-ups, e.g.
 * "2 misslyckade · 1 att kontrollera · 1 utan specifikation". Only non-zero
 * parts; renders nothing when the batch has nothing open.
 */
const InvoiceBatchExportSummaryBadge: React.FC<Props> = ({ summary }) => {
	const { t } = useTranslation();
	const text = describeExportSummary(summary, t as any);

	if (!text) return null;

	// A missing specification alone is a chore, not a failure
	const isSevere = !!summary && summary.failed + summary.held > 0;

	return (
		<span
			className={cn(
				"ml-2 inline-flex items-center whitespace-nowrap rounded-full border border-solid px-2 py-0.5 text-xs font-medium",
				isSevere
					? "border-red-200 bg-red-50 text-red-700"
					: "border-amber-300 bg-amber-50 text-amber-800"
			)}
		>
			{text}
		</span>
	);
};

export default InvoiceBatchExportSummaryBadge;
